<div
  id="badge_{{ badgeData?.key }}"
  class="inline-block py-1 px-2 text-xs rounded font-medium whitespace-nowrap {{ badgeData?.type }}"
  [style]="badgeData?.badgeStyle">
  <ng-content></ng-content>
  {{ badgeData?.value }}
</div>
